import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Divider } from "@mui/material";
import { toast } from "react-toastify";
import { EditOutlined } from "@mui/icons-material";

import {
  TripDetailContext,
  useTripDetailContext,
} from "contexts/TripDetailContext";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import EnableDisableButton from "components/Shared/EnableDisableButton";

import {
  useGetTripDetailQuery,
  useUpdateTripMutation,
} from "store/services/tripApi";

import { useAppMeta } from "hooks";
import TripBasicDetail from "./tripComponents/TripBasicDetail";
import TripDetailTab from "./tripComponents/TripDetailTab";

const TripDetailScreen = () => {
  const { id } = useParams();

  const breadcrumbs = [
    { title: "Trips", path: "/app/crm/trip/list" },
    { title: "Trip Detail" },
  ];

  // RTK Query
  const {
    data: tripDetail,
    isLoading: loadingTrip,
    error,
  } = useGetTripDetailQuery(id);

  useAppMeta("Trip Detail");

  return (
    <TripDetailContext.Provider value={{ tripDetail, loadingTrip }}>
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingTrip}
        toggleKey="TRIP_DETAIL"
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
          <TripBasicDetail />
          <Divider />
          <TripDetailTab />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </TripDetailContext.Provider>
  );
};

export default TripDetailScreen;

const PageActions = () => {
  const { tripDetail, loadingTrip } = useTripDetailContext();
  
  // RTK Query
  const [updateTrip, { isLoading: updatingTrip }] = useUpdateTripMutation();

  // methods
  const handleToggleTripStatus = async () => {
    try {
      const updatedStatus = !tripDetail?.isActive;

      await updateTrip({
        _id: tripDetail?._id,
        isActive: updatedStatus,
      }).unwrap();

      toast.info(
        `Trip successfully ${updatedStatus ? "Enabled" : "Disabled"}!`
      );
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't update Trip Status!");
    }
  };

  return (
    <div className="flex items-center gap-4">
      <EnableDisableButton
        isActive={tripDetail?.isActive}
        loading={loadingTrip || updatingTrip}
        onClick={handleToggleTripStatus}
      />

      <Link to={`/app/crm/trip/${tripDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};